__turbopack_context__.v({
  "button": "Tooltip-module-scss-module__FmPG3W__button",
  "close": "Tooltip-module-scss-module__FmPG3W__close",
  "iconButton": "Tooltip-module-scss-module__FmPG3W__iconButton",
  "iconClose": "Tooltip-module-scss-module__FmPG3W__iconClose",
  "iconOpen": "Tooltip-module-scss-module__FmPG3W__iconOpen",
  "popover": "Tooltip-module-scss-module__FmPG3W__popover",
});
